import mixpanel from 'mixpanel-browser';

const token = process.env.APP_MIXPANEL_TOKEN;

export const initializeMixpanel = () => {
  if (!token || process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.error(`Mixpanel token is missing! NODE: ${process.env.NODE_ENV}`);
    return;
  }

  mixpanel.init(token, {
    autocapture: false,
    record_sessions_percent: 100,
    api_host: 'https://api-eu.mixpanel.com',
  });
};

let currentIdentifiedUser = null;

export const identifyUser = (companyCode) => {
  if (token && companyCode) {
    if (currentIdentifiedUser && currentIdentifiedUser !== companyCode) {
      mixpanel.reset();
    }
    if (currentIdentifiedUser !== companyCode) {
      mixpanel.identify(companyCode);
      currentIdentifiedUser = companyCode;
    }
  }
};

export const formatRejection = (error) => {
  if (!error) return undefined;
  const details = Array.isArray(error.details) ? error.details : [];
  if (details.length === 0) {
    return error.code ? String(error.code) : undefined;
  }
  const parts = details
    .map((d) => {
      if (!d) return null;
      const field = d.field || '';
      const code = d.code || '';
      if (field && code) return `${field}: ${code}`;
      return field || code || null;
    })
    .filter(Boolean);
  if (parts.length === 0) return undefined;
  const joined = parts.join('; ');
  return joined.length > 200 ? `${joined.slice(0, 197)}...` : joined;
};

export const trackEvent = (eventName, properties = {}) => {
  if (token) {
    mixpanel.track(eventName, properties);
  }
};

export const MIXPANEL_EVENTS = {
  KYC_APPROVED: 'KYC Approved',
  KYC_REJECTED: 'KYC Rejected',
  KYC_COMMENT_SENT: 'KYC Comment Sent',
  KYB_APPROVED: 'KYB Approved',
  KYB_REJECTED: 'KYB Rejected',
  KYB_VALIDATED: 'KYB Validated',
  KYB_COMMENT_SENT: 'KYB Comment Sent',
  KYB_IMPLEMENTATION_UPDATED: 'KYB Implementation Updated',
};
